import React from "react";

import Slider from "@mui/material/Slider";

import "./slider-comp.styles.css";

const SliderComp = ({
  marks = [
    {
      value: 0,
      label: "0%",
    },
    {
      value: 100,
      label: "100%",
    },
  ],
  value,
  setValue,
  text,
  className,
}) => {
  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={`modal__meta-slider_body ${className ? className : ""}`}>
      <span className="modal__meta-slider_body-text">{text}</span>
      <span className="modal__meta-slider_body-value">{value}</span>
      <Slider
        aria-label="SLA"
        valueLabelDisplay="auto"
        value={value}
        onChange={handleSliderChange}
        marks={marks}
        sx={{
          '& .MuiSlider-markLabel[data-index="0"]': {
            left: "1.3% !important",
          },
          '& .MuiSlider-markLabel[data-index="1"]': {
            left: "98% !important",
          },
        }}
      />
    </div>
  );
};

export default SliderComp;
